var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDocVehicle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1558 66.4375C14.437 66.4375 12.9651 65.825 11.7401 64.6C10.5151 63.375 9.90368 61.9042 9.90577 60.1875V16.4375C9.90577 14.7188 10.5183 13.2469 11.7433 12.0219C12.9683 10.7969 14.4391 10.1854 16.1558 10.1875H59.9058C61.6245 10.1875 63.0964 10.8 64.3214 12.025C65.5464 13.25 66.1579 14.7208 66.1558 16.4375V60.1875C66.1558 61.9063 65.5433 63.3781 64.3183 64.6031C63.0933 65.8281 61.6224 66.4396 59.9058 66.4375H16.1558ZM16.1558 60.1875H59.9058V16.4375H16.1558V60.1875ZM19.2808 53.9375H56.7808L45.062 38.3125L35.687 50.8125L28.6558 41.4375L19.2808 53.9375Z",
    fill: "#9C4900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocVehicle);
export default __webpack_public_path__ + "static/media/ic_doc_vehicle.d3b5485683b8c11d962ebcffaf09b4c9.svg";
export { ForwardRef as ReactComponent };